















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
@Component({})
class kpTableItem extends Vue {
  @Prop()
  recordInfo;

  @Prop()
  wordLimit;

  // 'latestDevelopment': 要加时间和创建人
  // 其他就展示value
  @Prop()
  type;

  get recordText() {
    if (this.type === 'latestDevelopment') {
      return this.recordInfo
        ? (this.recordInfo.createBy ? this.recordInfo.createBy : '系统') + ' ' + this.recordInfo.createDate + ' ' + this.recordInfo.value
        : '';
    } else {
      return this.recordInfo ? this.recordInfo.value : '';
    }
  }

  created() {}
}
export default kpTableItem;
